import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"
import annotationPlugin from "chartjs-plugin-annotation"

Chart.register(annotationPlugin)

export default class extends Controller {
  static values = { config: Object }

  connect() {
    Chart.defaults.font.family = "'Inter', sans-serif"
    this.chart = new Chart(this.element, this.configValue)
  }

  disconnect() {
    this.chart.destroy()
  }
}
